// import CustomButton from '@/common/CustomButton';
// import Layout from '@/common/Layout';
// import {
//   ArrowLeftOutlined,
//   EditOutlined,
//   PlusOutlined,
//   SearchOutlined
// } from '@ant-design/icons';
// import { cards } from '..';
// import CustomTable from '@/common/Table';
// import { columnRenderer, headerRenderer } from 'utilities/helpers';
// import { Button, Input, Switch, Tag, Tooltip } from 'antd';
// import { useCallback, useEffect, useState } from 'react';
// import CreateProjectModal from '../components/CreateProjectModal';
// import { useDispatch, useSelector } from 'react-redux';
// import { getAllProjects, selectTaskSlice } from 'pages/Tasks/redux/slice';
// import { debounce } from 'lodash';
// import { useNavigate } from 'react-router-dom';

// export default function Projects() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [projects, setProjects] = useState([]);
//   const [Active, isActive] = useState(false);
//   const { loading } = useSelector(selectTaskSlice);

//   const handleGetAllProjects = (search = '') => {
//     const payload = { search, type: 'all' };
//     dispatch(getAllProjects(payload)).then((res) => {
//       if (res?.payload?.success) {
//         setProjects(res?.payload?.data);
//       }
//     });
//   };

//   useEffect(() => {
//     handleGetAllProjects('');
//   }, []);

//   const columns = [
//     {
//       title: headerRenderer('Project'),
//       dataIndex: 'project',
//       key: 'project',
//       width: '85%',
//       render: (text, record) =>
//         columnRenderer(
//           <div className="flex items-center gap-4">
//             <label>{text}</label>
//             {!record.is_active ? (
//               <Tag color="error" className="!text-[8px]">
//                 Deactivated
//               </Tag>
//             ) : null}
//           </div>
//         )
//     },
//     {
//       title: headerRenderer('Action'),
//       dataIndex: 'action',
//       key: 'action',
//       width: '15%',
//       render: (text, record) => (
//         <div className="grid grid-cols-4 gap-4 place-items-center">
//           <Tooltip title="Edit" overlayClassName="!text-xs">
//             <EditOutlined
//               onClick={() => setIsModalOpen(record.id)}
//               className="text-lg cursor-pointer text-[#0653fa] hover:!scale-105 "
//             />
//           </Tooltip>
//         </div>
//       )
//     }
//   ];

//   const debouncedSearch = useCallback(
//     debounce((value) => {
//       handleGetAllProjects(value);
//     }, 300),
//     []
//   );

//   const dataSource = projects.length
//     ? projects.map((project) => {
//         return {
//           project: project.project,
//           id: project.id,
//           is_active: project.is_active,
//           projectData: project
//         };
//       })
//     : [];

//   return (
//     <Layout>
//       <div className="flex flex-col gap-2 md:gap-6">
//         <div className="flex justify-end md:hidden">
//           <CustomButton type="outlined" onClick={() => navigate('/configure')}>
//             <ArrowLeftOutlined /> Back to Settings
//           </CustomButton>
//         </div>
//         <div className="flex flex-col items-start justify-between md:items-center md:flex-row">
//           <div className="flex flex-col gap-1">
//             <label className={'!text-xl md:!text-3xl !font-bold md:mt-0 mt-2'}>
//               Projects
//             </label>
//             <p className="!text-gray-500 text-balance text-xs md:text-sm !font-semibold">
//               {cards[1].description}
//             </p>
//           </div>

//           <div className="items-center hidden gap-4 md:flex">
//             <Input
//               placeholder="Search project"
//               prefix={<SearchOutlined style={{ color: '#00000072' }} />}
//               allowClear
//               className="!w-52"
//               onChange={(e) => debouncedSearch(e.target.value)}
//             />
//             <CustomButton
//               icon={<PlusOutlined />}
//               className={'!text-sm rounded-md hidden md:block'}
//               type="primary"
//               onClick={() => setIsModalOpen(true)}
//             >
//               Add Project
//             </CustomButton>
//             <CustomButton
//               type="outlined"
//               onClick={() => navigate('/configure')}
//             >
//               <ArrowLeftOutlined /> Back to Settings
//             </CustomButton>
//           </div>
//           <div className="flex items-center gap-4 md:hidden">
//             <Input
//               placeholder="Search project"
//               prefix={<SearchOutlined style={{ color: '#00000072' }} />}
//               allowClear
//               className="!w-auto"
//               onChange={(e) => debouncedSearch(e.target.value)}
//             />
//             <CustomButton
//               icon={<PlusOutlined />}
//               className={'!text-sm rounded-md block md:hidden'}
//               type="primary"
//               onClick={() => setIsModalOpen(true)}
//             >
//               Add Project
//             </CustomButton>
//           </div>
//         </div>

//         <div className="flex justify-end pr-[115px]">
//           <div
//             className="flex items-center w-fit h-8 gap-2 px-4 bg-white rounded-md"
//             style={{ border: '1px solid rgb(220, 220, 228)' }}
//           >
//             <span
//               className={
//                 !Active ? 'font-semibold text-[#0653fa]' : 'text-gray-500'
//               }
//             >
//               Active
//             </span>
//             <Switch
//               checked={Active}
//               size="small"
//               onChange={(checked) => isActive(checked)}
//             />
//             <span
//               className={
//                 Active ? 'font-semibold text-blue-600' : 'text-gray-500'
//               }
//             >
//               All
//             </span>
//           </div>
//         </div>

//         {/* table */}
//         <CustomTable
//           columns={columns}
//           dataSource={dataSource}
//           pagination={false}
//           loading={loading}
//           onChange={() => {}}
//           classname={'!min-w-fit'}
//           emptyText={'No projects to show'}
//         />

//         {/* modal */}
//         <CreateProjectModal
//           isOpen={isModalOpen}
//           setIsOpen={setIsModalOpen}
//           name={'Project'}
//           onAssign={handleGetAllProjects}
//           data={projects.find((project) => project.id === isModalOpen)}
//         />
//       </div>
//     </Layout>
//   );
// }

import CustomButton from '@/common/CustomButton';
import Layout from '@/common/Layout';
import {
  ArrowLeftOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { cards } from '..';
import CustomTable from '@/common/Table';
import { columnRenderer, headerRenderer } from 'utilities/helpers';
import { Button, Input, Switch, Tag, Tooltip } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import CreateProjectModal from '../components/CreateProjectModal';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProjects, selectTaskSlice } from 'pages/Tasks/redux/slice';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';

export default function Projects() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [Active, isActive] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const { loading } = useSelector(selectTaskSlice);

  // const handleGetAllProjects = (search = '') => {
  //   const payload = { search, type: 'all' };
  //   dispatch(getAllProjects(payload)).then((res) => {
  //     if (res?.payload?.success) {
  //       setProjects(res?.payload?.data);
  //     }
  //   });
  // };

  const handleGetAllProjects = (search = '') => {
    const payload = { search, type: 'all' };
    dispatch(getAllProjects(payload)).then((res) => {
      if (res?.payload?.success) {
        setAllProjects(res.payload.data); // store full data
      }
    });
  };

  useEffect(() => {
    const filtered = !Active
      ? allProjects.filter((p) => p.is_active)
      : allProjects;
    setProjects(filtered);
  }, [Active, allProjects]);

  useEffect(() => {
    handleGetAllProjects('');
  }, []);

  const columns = [
    {
      title: headerRenderer('Project'),
      dataIndex: 'project',
      key: 'project',
      width: '85%',
      render: (text, record) =>
        columnRenderer(
          <div className="flex items-center gap-4">
            <label>{text}</label>
            {!record.is_active ? (
              <Tag color="error" className="!text-[8px]">
                Deactivated
              </Tag>
            ) : null}
          </div>
        )
    },
    {
      title: headerRenderer('Action'),
      dataIndex: 'action',
      key: 'action',
      width: '15%',
      render: (text, record) => (
        <div className="grid grid-cols-4 gap-4 place-items-center">
          <Tooltip title="Edit" overlayClassName="!text-xs">
            <EditOutlined
              onClick={() => setIsModalOpen(record.id)}
              className="text-lg cursor-pointer text-[#0653fa] hover:!scale-105 "
            />
          </Tooltip>
        </div>
      )
    }
  ];

  const debouncedSearch = useCallback(
    debounce((value) => {
      const filtered = allProjects.filter((p) => {
        const matchesSearch = p.project
          ?.toLowerCase()
          .includes(value.toLowerCase());
        const matchesStatus = Active ? p.is_active : true;
        return matchesSearch && matchesStatus;
      });
      setProjects(filtered);
    }, 300),
    [Active, allProjects]
  );

  // const debouncedSearch = useCallback(
  //   debounce((value) => {
  //     handleGetAllProjects(value);
  //   }, 300),
  //   []
  // );

  const dataSource = projects.length
    ? projects.map((project) => {
        return {
          project: project.project,
          id: project.id,
          is_active: project.is_active,
          projectData: project
        };
      })
    : [];

  return (
    <Layout>
      <div className="flex flex-col gap-2 md:gap-6">
        <div className="flex justify-end md:hidden">
          <CustomButton type="outlined" onClick={() => navigate('/configure')}>
            <ArrowLeftOutlined /> Back to Settings
          </CustomButton>
        </div>
        <div className="flex flex-col items-start justify-between md:items-center md:flex-row">
          <div className="flex flex-col gap-1">
            <label className={'!text-xl md:!text-3xl !font-bold md:mt-0 mt-2'}>
              Projects
            </label>
            <p className="!text-gray-500 text-balance text-xs md:text-sm !font-semibold">
              {cards[1].description}
            </p>
          </div>

          <div className="items-center hidden gap-4 md:flex">
            <Input
              placeholder="Search project"
              prefix={<SearchOutlined style={{ color: '#00000072' }} />}
              allowClear
              className="!w-52"
              onChange={(e) => debouncedSearch(e.target.value)}
            />
            <CustomButton
              icon={<PlusOutlined />}
              className={'!text-sm rounded-md hidden md:block'}
              type="primary"
              onClick={() => setIsModalOpen(true)}
            >
              Add Project
            </CustomButton>
            <CustomButton
              type="outlined"
              onClick={() => navigate('/configure')}
            >
              <ArrowLeftOutlined /> Back to Settings
            </CustomButton>
          </div>
          <div className="flex items-center gap-4 md:hidden">
            <Input
              placeholder="Search project"
              prefix={<SearchOutlined style={{ color: '#00000072' }} />}
              allowClear
              className="!w-auto"
              onChange={(e) => debouncedSearch(e.target.value)}
            />
            <CustomButton
              icon={<PlusOutlined />}
              className={'!text-sm rounded-md block md:hidden'}
              type="primary"
              onClick={() => setIsModalOpen(true)}
            >
              Add Project
            </CustomButton>
          </div>
        </div>

        <div className="flex justify-end ">
          <div
            className="flex items-center w-fit h-8 gap-2 px-4 bg-white rounded-md"
            style={{ border: '1px solid rgb(220, 220, 228)' }}
          >
            <span
              className={
                !Active ? 'font-semibold text-[#0653fa]' : 'text-gray-500'
              }
            >
              Active
            </span>
            <Switch
              checked={Active}
              size="small"
              onChange={(checked) => isActive(checked)}
            />
            <span
              className={
                Active ? 'font-semibold text-blue-600' : 'text-gray-500'
              }
            >
              All
            </span>
          </div>
        </div>

        {/* table */}
        <CustomTable
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          loading={loading}
          onChange={() => {}}
          classname={'!min-w-fit'}
          emptyText={'No projects to show'}
        />

        {/* modal */}
        <CreateProjectModal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          name={'Project'}
          onAssign={handleGetAllProjects}
          data={projects.find((project) => project.id === isModalOpen)}
        />
      </div>
    </Layout>
  );
}
